import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "rd_admin_token";

export function getAdminToken() {
    return localStorage.getItem(TOKEN_KEY);
}

export function setAdminToken(token) {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
}

export function clearAdminToken() {
    localStorage.removeItem(TOKEN_KEY);
}

export const adminAxios = axios.create({ baseURL: API });

adminAxios.interceptors.request.use((config) => {
    const token = getAdminToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

adminAxios.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            clearAdminToken();
            if (!window.location.pathname.startsWith("/admin/login")) {
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    },
);

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
